import { render, staticRenderFns } from "./sidebar_right.vue?vue&type=template&id=61414d80&"
import script from "./sidebar_right.vue?vue&type=script&lang=js&"
export * from "./sidebar_right.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MenuItem: require('/var/web/bet777.es/components/menu/item.vue').default,ButtonToggle: require('/var/web/bet777.es/components/button/toggle.vue').default})
